module.exports = __webpack_public_path__ + "img/hasklig-dark.86e73584.png";